import React from "react";

import { Link, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

import "bootstrap-icons/font/bootstrap-icons.css";

import "../App.css";

import SidebarNavSections from "./SidebarNavSections";

import SidebarPlanSummary from "./SidebarPlanSummary";

import UserMenu from "./UserMenu";

import LegalFooterLinks from "./shared/LegalFooterLinks";

import { useSidebarNavSections } from "../hooks/useSidebarNavSections";

import { trackCtaClicked } from "../analytics/analytics";
import { ANALYTICS_CTAS } from "../analytics/analytics.constants";
import logo from "../assets/echovibe.png";



const Sidebar = () => {
  const location = useLocation();
  const navSections = useSidebarNavSections();

  const { data: planData, loading: planLoading, loaded: planLoaded } = useSelector(

    (state) => state.plan

  );



  const isActive = (path) => path === location.pathname;

  return (

    <aside

      className="z-40 hidden h-full w-[268px] shrink-0 flex-col   bg-white border-r shadow-md  md:flex"

    >

      <div className="flex min-h-0 flex-1 flex-col gap-0 overflow-y-auto px-3 pb-4 pt-3 no-scrollbar md:px-4 md:pb-5 md:pt-4">

        <div className="mb-2.5 shrink-0 border-b border-slate-200/50 pb-2.5">

          <div className="flex items-center justify-between gap-2">

            <Link to="/" className="flex min-w-0 flex-1 items-center gap-2" title="Home" onClick={() => trackCtaClicked(ANALYTICS_CTAS.NAV_LOGO)}>

              <img src={logo} alt="EzePulse" className="h-8 w-auto max-w-[120px] object-contain object-left" />

            </Link>

            <UserMenu className="ml-auto" />

          </div>

        </div>



        <div className="min-h-0 flex-1">

          <SidebarNavSections sections={navSections} isActive={isActive} />

        </div>



        <SidebarPlanSummary
          className="mt-auto shrink-0"
          planData={planData}
          planLoading={planLoading}
          planLoaded={planLoaded}
        />



        <LegalFooterLinks className="mb-0 mt-2 whitespace-nowrap px-1 text-center text-[10px] leading-none text-slate-500" />

      </div>

    </aside>

  );

};



export default Sidebar;

